import Button from 'components/_parts/atoms/button';
import CustomTable from 'components/_parts/atoms/table';
import { useDeleteSkillGroup, useSkillGroupList } from 'components/company/api/useCompetencyAndSkillGroup';
import LoadingCustom from 'components/layouts/loading/loading';
import moment from 'helpers/dayjsWrapper';
import { useOuterClick } from 'providers/OutsideClick';
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import ModalSkillComp from '../modal';

interface PropsType {
  t : (e:string) => string
}

const ButtonEdit = styled(Button)`
  width: 100%;
  max-width: 70px;
  height: 24px;
  float: right;
`;
const CustomTableMod = styled.div`
  .rdt_TableBody {
    height: 500px;
    overflow: auto;
  }
`;
const customStyles = {
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'Quicksand',
      padding: '0px',
      justifyContent: 'start',
    },
  },
  cells: {
    style: {
      padding: '0px',
      justifyContent: 'start',
    },
  },
  rows: {
    style: {
      fontFamily: 'Quicksand',
      minHeight: '35px', // override the row height
      borderRadius: 0,
      filter: 'none',
      borderBottom: 'unset !important',
    },
  },
};

function Index(props : PropsType) {
  const { t } = props;
  const companyId = localStorage.getItem('company_id');

  const [showModal, setShowModal] = useState(false);
  const [dataEdit, setDataEdit] = useState(null);
  const [id, setId] = useState(null);
  const [typeForm, setTypeForm] = useState('');

  const { data: dataListSkillGroup, isFetching: loaderSkillGroup } = useSkillGroupList(companyId, true);

  const listSkillGroup = useMemo(() => {
    if (loaderSkillGroup) return [];

    return dataListSkillGroup.filter((val) => val.status === 'active');
  }, [dataListSkillGroup]);

  const { mutate: deleteSkillGroup } = useDeleteSkillGroup();

  const innerRef = useOuterClick((e) => {
    const target = e?.target as HTMLElement;
    const className = target?.className;

    if (className && typeof className === 'string') {
      if (className === 'modal fade show' || className.includes('cs_modal-bg')) {
        setShowModal(false);
        setId(null);
      }
    }
  });

  const handleDelete = (id:string) => {
    const dataPayload = {
      skill_group_action: 'delete',
      competency_skill_group_id: id,
    };
    deleteSkillGroup(dataPayload);
  };

  const handleEdit = (data) => {
    setDataEdit(data);
    setShowModal(true);
    setTypeForm('update');
  };

  // ACTION
  const actionTable = ({ row }) => (
    <>
      <ButtonEdit
        icon="edit"
        func={() => handleEdit(row)}
      >
        <span className="tw-ml-[7px]">
          {t('org.structure_view.modal.edit')}
        </span>
      </ButtonEdit>
      <Button
        icon="delete"
        className="delCompLib"
        func={() => handleDelete(row.competency_skill_group_id)}
      />
    </>
  );

  const columns = [
    {
      name: t('company.title_skill_group'),
      sortField: true,
      selector: (row) => row.skill_group_name,
      cellStyle: { verticalAlign: 'middle' },
    },
    {
      name: t('company.status'),
      sortField: true,
      selector: (row) => row.status,
    },
    {
      name: t('org.employee.created_at'),
      sortField: true,
      selector: (row) => moment(row.created_at).format('D MMM YYYY') ?? '-',
      center: true,
      width: '20%',
    },
    {
      name: t('org.employee.action'),
      sortField: true,
      style: {
        gap: '8px',
        justifyContent: 'center',
      },
      center: true,
      width: '16%',
      cell: (row) => actionTable({ row }),
    },
  ];

  return (
    <>
      {showModal && (
      <ModalSkillComp
        innerRef={innerRef}
        modal={showModal}
        funcModal={setShowModal}
        ids={id}
        funcId={() => setId}
        typeForm={typeForm}
        t={t}
        dataEdit={dataEdit}
      />
      )}
      <div
        className="tab-pane active position-relative"
        id="list_skill"
        role="tabpanel"
        style={{
          minHeight: '700px',
        }}
      >
        { loaderSkillGroup ? <LoadingCustom /> : (
          <>
            <div className="row">
              <div className="col-8">
                <h4 className="title">Skill Group Management</h4>
              </div>
              <div className="col-4">
                <Button
                  icon="create"
                  style={{ width: '92px', height: '40px', float: 'right' }}
                  func={() => {
                    setShowModal(true);
                    setTypeForm('create');
                    setDataEdit(null);
                  }}
                >
                  &nbsp;&nbsp;
                  {t('board.add')}
                </Button>
              </div>
            </div>
            <CustomTableMod>
              <CustomTable
                columns={columns}
                data={listSkillGroup}
                customStyles={customStyles}
              />
            </CustomTableMod>
          </>
        ) }
      </div>
    </>
  );
}

export default Index;
